const getAccessor = (col) => {
  switch (col.name) {
    default:
      return col.name;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'name':
      return 'AvatarText';
    case 'email':
      return 'Email';
    case 'role.name':
      return 'Role';
    case 'roles':
      return 'Role';
    default:
      return 'Text';
  }
};

const getAssetColConfig = (col) => {
  switch (col.name) {
    case 'id':
      return 'TYPE';
    default:
      return 'Text';
  }
};

const isEditable = (col) => {
  switch (col.name) {
    default:
      return false;
  }
};

const getRuleAttribute = (f) => {
  switch (f.name) {
    case 'prioritizedId':
      return 'displayId';
    default:
      return f.name;
  }
};

export {
  getAccessor,
  getType,
  getRuleAttribute,
  isEditable,
  getAssetColConfig
};
